export const isElementInViewport = (el: HTMLElement): boolean => {
    // Provides information about size & position of HTML element relative to the viewport
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
};
